(function () {
  var lanes = document.querySelectorAll('.pillar-lane');
  if (!lanes.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  lanes.forEach(function (lane) {
    observer.observe(lane);
  });
})();
